export const ROUTE_SEGMENTS = {
    start: 'start',
    login: 'login',
    authenticated: 'authenticated',
    // TODO: Remove signup path once we fully switched to Entra.
    signup: 'signup',
    signedUp: 'signedup',
    userWithoutOrg: 'user-without-org',
    profile: 'profile',
    organizations: 'organizations',
    users: 'users',
    systemLicences: 'system-licences',
    products: 'products',
    data: 'data',
    sites: 'sites',
    services: 'services',
    appService: 'appservice',
    createTemporaryLicenses: 'create-temporary-licenses',
    join: 'join',
    acceptedInvitation: 'accepted-invitation',
    expired: 'expired',
    wrongEmail: 'wrong-email',
    userNotInOrg: 'user-not-in-org',
    allUsers: 'all-users',
    gmgActivity: 'gmg-activity',
    activities: 'activities',
    partnerPortal: 'partner-portal',
} as const;

export const ROUTES = {
    root: '/',
    start: `/${ROUTE_SEGMENTS.start}`,
    login: `/${ROUTE_SEGMENTS.login}`,
    authenticated: `/${ROUTE_SEGMENTS.authenticated}`,
    signup: `/${ROUTE_SEGMENTS.signup}`,
    signedUp: `/${ROUTE_SEGMENTS.signedUp}`,
    userWithoutOrg: `/${ROUTE_SEGMENTS.userWithoutOrg}`,
    profile: `/${ROUTE_SEGMENTS.profile}`,
    organizations: `/${ROUTE_SEGMENTS.organizations}`,
    organization: `/${ROUTE_SEGMENTS.organizations}/:orgId`,
    allUsers: `/${ROUTE_SEGMENTS.organizations}/${ROUTE_SEGMENTS.allUsers}`,
    gmgActivity: `/${ROUTE_SEGMENTS.organizations}/${ROUTE_SEGMENTS.gmgActivity}`,
    activities: `/${ROUTE_SEGMENTS.organizations}/${ROUTE_SEGMENTS.activities}`,
    services: `/${ROUTE_SEGMENTS.services}`,
    appService: `/${ROUTE_SEGMENTS.services}/${ROUTE_SEGMENTS.appService}`,
    createTemporaryLicenses: `/${ROUTE_SEGMENTS.services}/${ROUTE_SEGMENTS.appService}/${ROUTE_SEGMENTS.createTemporaryLicenses}`,
    systemLicencesService: `/${ROUTE_SEGMENTS.services}/${ROUTE_SEGMENTS.appService}/${ROUTE_SEGMENTS.systemLicences}`,
    join: `/${ROUTE_SEGMENTS.join}`,
    acceptedInvitation: `/${ROUTE_SEGMENTS.acceptedInvitation}`,
} as const;

export const organizationPaths = {
    root: (orgId: string) => `${ROUTES.organizations}/${orgId}`,
    users: (orgId: string) => `${ROUTES.organizations}/${orgId}/${ROUTE_SEGMENTS.users}`,
    systemLicences: (orgId: string) => `${ROUTES.organizations}/${orgId}/${ROUTE_SEGMENTS.systemLicences}`,
    products: (orgId: string) => `${ROUTES.organizations}/${orgId}/${ROUTE_SEGMENTS.products}`,
    data: (orgId: string) => `${ROUTES.organizations}/${orgId}/${ROUTE_SEGMENTS.data}`,
    activities: (orgId: string) => `${ROUTES.organizations}/${orgId}/${ROUTE_SEGMENTS.activities}`,
    sites: (orgId: string) => `${ROUTES.organizations}/${orgId}/${ROUTE_SEGMENTS.sites}`,
} as const;

export const SYSADMIN_VIEW_ROUTES: ReadonlyArray<string> = [ROUTES.organizations, ROUTES.allUsers, ROUTES.gmgActivity];

export const invitationPaths = {
    joinUser: (userId: string) => `${ROUTES.join}/${userId}`,
    joinUserNotInOrg: (userId: string) => `${ROUTES.join}/${userId}/${ROUTE_SEGMENTS.userNotInOrg}`,
    acceptedInvitationUser: (userId: string) => `${ROUTES.acceptedInvitation}/${userId}`,
    acceptedExpired: (userId: string) => `${ROUTES.acceptedInvitation}/${userId}/${ROUTE_SEGMENTS.expired}`,
    acceptedWrongEmail: (userId: string) => `${ROUTES.acceptedInvitation}/${userId}/${ROUTE_SEGMENTS.wrongEmail}`,
    acceptedUserNotInOrg: (userId: string) => `${ROUTES.acceptedInvitation}/${userId}/${ROUTE_SEGMENTS.userNotInOrg}`,
} as const;
